const IMG_CDN_URL = "https://img-cdn.flux.ai";
const CDN_URL = "https://cdn.flux.ai";
const BUCKET = "graviton-electric-symbols";

/**
 * UTF-8-safe base64 encode. Native `btoa()` throws an InvalidCharacterError on
 * characters outside the Latin1 range (e.g. CJK asset keys), so encode the
 * string to UTF-8 bytes first. Mirrors `btoaSafe` in `frontend/src/helpers/btoa.ts`.
 */
function toBase64(input: string): string {
    const bytes = new TextEncoder().encode(input);
    let binary = "";
    for (const byte of bytes) {
        binary += String.fromCharCode(byte);
    }
    return btoa(binary);
}

export function getProcessedImageUrl(key: string, size = 124, fit = "contain"): string {
    const imageRequest = {
        bucket: BUCKET,
        key,
        edits: {
            resize: {
                width: size,
                height: size,
                fit,
                background: {r: 0, g: 0, b: 0, alpha: 0},
            },
        },
        outputFormat: "webp",
    };
    return `${IMG_CDN_URL}/${toBase64(JSON.stringify(imageRequest))}`;
}

export function getPreviewImageUrl(previewImage: string | undefined | null, size = 124): string | undefined {
    if (!previewImage) return undefined;
    if (previewImage.toLowerCase().endsWith(".svg")) {
        return `${CDN_URL}/${previewImage}`;
    }
    return getProcessedImageUrl(previewImage, size);
}
